module.exports = __webpack_public_path__ + "img/Deco_table_mariage.294e5de.jpg";